import { DynamicEmsSettingsModel } from 'src/Libs/dynamic-power-prices/types'
import { Ai360SettingsFormValues } from '../types'
import { FeedInPowerModel } from 'src/Libs/installation-settings/model/feed-in-power.model'
import { InstallationPowerPriceDto } from 'src/Libs/flow/installation/api'
import { convertPriceToCents } from '../utils'

type ReturnType = {
  initialValues: Ai360SettingsFormValues
}

export const useSettingsFormInitializer = (
  dynamicEmsSettings: DynamicEmsSettingsModel | null,
  feedInPowerData: FeedInPowerModel | undefined,
  powerPrice: InstallationPowerPriceDto | null
): ReturnType => {
  const initialValues: Ai360SettingsFormValues = {
    isAI360Active: dynamicEmsSettings?.isActive ?? false,
    isSGReadyActive: dynamicEmsSettings ? !!dynamicEmsSettings.isSgReadyEnabled : false,
    isChargingFromPVActive: dynamicEmsSettings ? !!dynamicEmsSettings.feedInTariffType : false,
    isChargingFromGridActive: dynamicEmsSettings ? !!dynamicEmsSettings.isDynamicEmsEnabledForBattery : false,
    pvSettings: {
      feedInTariffType: dynamicEmsSettings?.feedInTariffType ?? '',
      feedInTariff: powerPrice?.price == null ? '' : convertPriceToCents(powerPrice.price),
      powerReductionFrom: feedInPowerData?.powerReduction ?? undefined,
    },
  }

  return { initialValues }
}
